import http from "@/utils/axios";
import cookie from "@/utils/cookie";
//引入formatDatetime方法
import {formatDatetime} from '@/utils/dateUtil'

const state = {
  searchCondition: {
    name: '',
    parentId: '',
  },
  //机构的基本信息
  department: {},
  //tree格式的dept数据
  treeDeptData: [],
  deptListData: [],
  deptListDataPage: 0,
  currentPage: 1,
}

const mutations = {

  //加载部门的tree格式的数据
  loadingTreeDeptData(state) {
    let obj = {
      token: cookie.getCookie('token'),
      data: {
        pageSize: -1,
      }
    }
    let response = http.post(window.config.api.baseUrl + '/eims-api/department/findCurrentAndSub', obj)
    response.then(value => {
      if (value.data.code === '00000') {
        state.treeDeptData = value.data.data.departments
      }
    })
    return response
  },

  findDeptListData(state, obj) {
    http.post(window.config.api.baseUrl + '/eims-api/department/findCurrentAndSub', obj).then(value => {
      if (value.data.code === '00000') {
        state.deptListDataPage = value.data.data.total
        let deptListData = value.data.data.departments;
        state.deptListData = []
        for (let dept of deptListData) {
          //格式化显示的时间
          dept.createTm = formatDatetime(dept.createTm, 'yyyy-MM-dd \n hh:mm:ss')
          dept.lastModTm = formatDatetime(dept.lastModTm, 'yyyy-MM-dd \n hh:mm:ss')
          state.deptListData.push(dept)
        }
        //缓存查询条件
        state.searchCondition.name = obj.data.name
        state.searchCondition.parentId = obj.data.parentId
      }
    })
  },

  //清空缓存数据
  clearDeptListData(state, obj) {
    state.searchCondition.name = ''
    state.treeDeptData = []
    state.deptListData = []
    state.deptListDataPage = 0
    state.currentPage = 1
  },

}

const actions = {
  //加载部门的tree格式的数据
  loadingTreeDeptData: ({commit, state}) => {
    commit('loadingTreeDeptData')
  },

  //查询部门的结果数据
  findDeptListData: ({commit, state}, obj) => {
    commit('findDeptListData', obj)
  },

  //清空机构数据
  clearDeptListData: ({commit, state}, obj) => {
    commit('clearDeptListData', obj)
  },

  //通过id查询机构的基本数据
  findById: ({commit, state}, deptId) => {
    let requestData = {
      token: cookie.getCookie('token'),
      data: {
        id: deptId,
      }
    }
    let response = http.post(window.config.api.baseUrl + '/eims-api/department/findById', requestData);
    response.then(value => {
      if (value.data.code === '00000') {
        let department = value.data.data.department
        //设置部门数据
        state.department = department
        //格式化显示的时间
        state.department.createTm = formatDatetime(department.createTm, 'yyyy-MM-dd \n hh:mm:ss')
        state.department.lastModTm = formatDatetime(department.lastModTm, 'yyyy-MM-dd \n hh:mm:ss')
      }
    })
    return response
  },
}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/departmentStore.js